<template>
  <v-snackbar
    v-model="notification.showing"
    :color="notification.color"
    :timeout="notification.timeout"
    top
  >
    {{ notification.message }}
    <template v-slot:action="{ attrs }">
      <v-btn
        color="white"
        text
        v-bind="attrs"
        @click="notification.showing = false"
        >Close</v-btn
      >
    </template>
  </v-snackbar>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "Notification",
  computed: {
    ...mapGetters(["notification"]),
  },
};
</script>
